export const isNodeEnvironment = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
export const isWebEnvironment = !isNodeEnvironment && typeof window !== 'undefined' && typeof window.document !== 'undefined';
export const isReactNativeEnvironment = !isNodeEnvironment && !isWebEnvironment && typeof global !== 'undefined';

export const getTargetWindow = () => isWebEnvironment ? window : (isReactNativeEnvironment ? global.window : {});

export const shouldLog = () => {
  const level = getTargetWindow()._signalRLoggingLevel || 'none';
  return level !== 'none';
};

export const signalRLog = (...args) => {
  if (shouldLog()) {
    console.log('[SignalR]', ...args);
  }
};
